import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { trainerReviews_ } from '../../../slices/reportSlice';
import { useModuleSettings } from '../../../components/moduleSettingsContext/ModuleSettingsContext';
import { useLocation } from 'react-router-dom';
import { decrypt } from '../../../common/enc_dec';
import { trainers } from '../../../slices/trainerSlice';
import TrainerDetailsView from './trainerDetailsView';
import ReviewsList from './reviewsList';

const TrainerReviews = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { id } = location?.state || {};
    const queryParams = new URLSearchParams(location.search);
    const _id = decrypt(queryParams.get("id"));
    const trainerId = id || _id;
    const { filter, search, page, limit } = useModuleSettings();

    useEffect(() => {
        if (trainerId) {
            dispatch(trainers({ id: trainerId }));
        }
    }, [dispatch, filter, page, limit, search, trainerId]);

    return (
        <div className="content-page">
            <TrainerDetailsView />

            {/* {trainerReviews && ( */}
                <div className="card mt-3 shadow-sm">
                    <div className="card-body">
                        <ReviewsList />
                    </div>
                </div>
            {/* )} */}
        </div>
    );
};

export default TrainerReviews;